import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@/app/providers/theme-provider'
import { QueryProvider } from '@/app/providers/query-provider'
import { AuthProvider } from '@/shared/lib/auth/auth-context'
import { AnalyticsProvider } from '@/app/providers/analytics-provider'
import { router } from '@/app/routes/routes'
import '@/shared/lib/i18n/i18n'

export function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AuthProvider>
          <AnalyticsProvider>
            <RouterProvider router={router} />
          </AnalyticsProvider>
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  )
}
